import { ListItem, ListItemText, TextField, Typography } from "@mui/material"
import theme from "css/theme/light"
import React from "react"
import { useTranslation } from "react-i18next"
import { StyledFormLabel } from "shared/styled/Global"
import { IFormTextFieldProps } from "./formtextfield.interface"

const FormTextField: React.FC<IFormTextFieldProps> = (props) => {
  const { t } = useTranslation()
  const { id, value, labelDefault, labelKey, optional, rows, handleBlur, handleChange, dataType } = props

  return (
    <ListItem sx={{ padding: 0 }}>
      <ListItemText
        primary={
          <StyledFormLabel>
            <Typography variant="labelLarge" fontWeight={500}>
              {t(labelKey || "", { defaultValue: labelDefault })} {!optional && "*"}
            </Typography>
          </StyledFormLabel>
        }
        secondary={
          <TextField
            sx={{ background: theme.palette.background.paper }}
            fullWidth
            defaultValue={value}
            onChange={handleChange}
            onBlur={handleBlur}
            type={dataType === 1 ? "number" : "text"}
            {...props}
            variant="outlined"
            multiline={rows !== undefined}
            rows={rows}
          />
        }
      />
    </ListItem>
  )
}

export default FormTextField
